import { Typography } from "@pankod/refine-antd";
import { ShowUserCard } from "components/profile/showUserCard";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { IBaseProps } from "interfaces";
import { greyStyle } from "scripts/site";
import { displayRelativeDate } from "./displayRelativeDate";
dayjs.extend(relativeTime);

export const UpdatedBy: React.FC<IBaseProps> = (propObj: IBaseProps) => {
    if (propObj) {
        return (
            <>
                <Typography.Text style={greyStyle}>Updated by </Typography.Text>
                <ShowUserCard id={propObj.updatedBy}></ShowUserCard>
                {displayRelativeDate(propObj?.updatedAt)}
            </>
        );
    }
    return <></>;
};